import { Theme } from '@teetsh/app/src/containers/Sidebar/themes';
import React from 'react';
import { useSidebarStatus } from './useSidebarStatus';
import { useIsBelowBreakpoint } from '@teetsh/app/src/components/ResponsiveSwitcher/useIsBelowSize';
import { MenuItem as MenuItemTeacher } from '@teetsh/app/src/containers/Header/useGetTeacherRoutes';
import { MenuItem as MenuItemDirector } from '@teetsh/app/src/containers/Header/useGetDirectorRoutes';
import { MenuItem } from 'components/NavLink/MenuItem';

type MenuItemType = MenuItemTeacher | MenuItemDirector;

interface Props {
  minimal?: boolean;
  pathname: string;
  item: MenuItemType;
  theme: Theme;
}

function isActive(item: MenuItemType, pathname: string) {
  // Check if item itself is active
  const itemIsActive = item.isActiveFct
    ? item.isActiveFct(pathname)
    : item.route && pathname.includes(item.route);

  // If item has subItems, check if any subItem is active
  const subItemIsActive = item.subItems?.some(sub =>
    sub.isActiveFct
      ? sub.isActiveFct(pathname)
      : sub.route && pathname.includes(sub.route),
  );

  // Consider active if the item itself OR any subitem is active
  return !!(itemIsActive || subItemIsActive);
}

export function NavItem(props: Props) {
  const { minimal, item, pathname, theme } = props;
  const { close } = useSidebarStatus();
  const isMobile = useIsBelowBreakpoint('md');

  const active = isActive(item, pathname);

  return (
    <MenuItem
      item={{
        title: item.title,
        route: item.route,
        icon: item.icon,
        disabled: item.disabled,
        subItems: item.subItems?.map(subItem => ({
          ...subItem,
          active: subItem.isActiveFct
            ? subItem.isActiveFct(pathname)
            : subItem.route && pathname.includes(subItem.route),
        })),
        active,
      }}
      theme={theme}
      minimal={minimal}
      onClose={() => {
        if (isMobile) {
          close();
        }
      }}
    />
  );
}
